import React, { Component } from 'react';
import { LoadingIndicator, ProgressBar, Card, Tile } from '../../components';
import { ThemeColors } from '../../theme';
import LearningContent from '../course/learning-content';

const INITIAL_STATE = {
  cardIndex: 0,
  progress: 0,
};
class Course extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (!this.props.course) {
      this.props.loadCourse({ id: this.props.match.params.courseId });
    }
  }


  loadCourse(course) {
    this.props.loadCourse(course);
    this.props.history.push(`/courses/${course.id}`);
  }

  renderCard(card) {
    return <div className="card"><LearningContent content={card} key={card && card.id} showAll /></div>;
  }

  renderCards(cards) {
    return cards.map(this.renderCard.bind(this));
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.course) {
      return null;
    }

    const containerOuterStyle = {
      backgroundColor: '#f8f8f8',
      overflow: 'hidden',
    };

    const outerCardContainerStyle = {
      marginBottom: '40px',
      overflow: 'hidden',
    };

    const cardContainerStyle = {
      marginBottom: '40px',
      overflow: 'hidden',
    };

    return (
      <div>
        <div style={containerOuterStyle}>
          <div className="col-md-12 col-lg-10 col-lg-offset-1" style={{ paddingLeft: '35px' }}>
            <div>
              <h1 style={{ color: ThemeColors.accent2Color }}>{this.props.course.name}</h1>
              <p style={{ color: ThemeColors.accent2Color }}>{this.props.course.description}</p>
            </div>

          </div>
        </div>
        <div style={outerCardContainerStyle}>
          <div className="col-sm-12 col-md-10 col-lg-offset-1" style={cardContainerStyle}>
            {this.renderCards(this.props.cards)}
          </div>
        </div>
      </div>
    );
  }
}

export default Course;



// WEBPACK FOOTER //
// ./src/app/main/course-all/course.js